const CONJUNCTIONS = new Set(['e', 'ed', 'o', 'od', 'né', 'sia'])

export function titleCaseItalian(input: string): string {
    if (!input) {
        return ''
    }

    const capitalize = (s: string) =>
        s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : s

    const capWithApostrophe = (s: string) =>
        s
            .split("'")
            .map((part, i) => (i === 0 ? capitalize(part) : capitalize(part)))
            .join("'")

    const capToken = (token: string, isFirstWord: boolean) => {
        const lower = token.toLowerCase()
        if (!isFirstWord && CONJUNCTIONS.has(lower)) {
            return lower
        }

        if (token.includes("'")) {
            return capWithApostrophe(lower)
        }

        return capitalize(lower)
    }

    return input
        .split(/\s+/)
        .map((word, i) =>
            word
                .split('-')
                .map((t) => capToken(t, i === 0))
                .join('-')
        )
        .join(' ')
}
